/* hej-balk-teksten — levert de teksten voor de twee balken bovenaan de winkel, in de juiste
 * taal.
 *
 * Eén verantwoordelijkheid: taal bepalen en tekst opzoeken. Het tonen van een balk gebeurt in
 * assets/hej-header-geo.js en assets/hej-geen-levering.js; die twee delen dit bestand, zodat
 * de regel op één plek staat.
 *
 * ── De regel ─────────────────────────────────────────────────────────────────────────
 * Een balk staat in de taal van de winkel waar hij je naartoe stuurt.
 *
 *   wisselbalk, land  -> de taal van de winkel van dat land   (marktaal)
 *   wisselbalk, taal  -> de taal die wordt aangeboden          (alleen België)
 *   rode balk         -> de taal van de pagina                 (paginataal)
 *
 * De eerste opzet keek naar navigator.language. Dat leek de eerlijkste bron, maar het gaf
 * één zin in de taal van de bezoeker midden op een pagina in een andere taal, zonder winkel
 * om naartoe te gaan. Door de gebruiker gevonden op 2026-09-17 met een Nederlandse browser
 * en de VPN op Costa Rica.
 *
 * De browsertaal telt nog op één plek mee: bij een doelwinkel met twee talen (België) kiest
 * hij de taal van de ZIN. Zie zinstaal() hieronder voor waarom dat daar wel verantwoord is.
 *
 * De teksten zelf staan in snippets/hej-balk-teksten.liquid, met de toelichting waarom ze
 * niet in de vertaalbestanden kunnen staan.
 */
(function () {
  var TALEN = ['nl', 'de', 'fr', 'en'];

  var blok = document.querySelector('[data-hej-balk-teksten]');
  if (!blok) return;

  var data;
  try { data = JSON.parse(blok.textContent); } catch (e) { return; }

  var paginataal = TALEN.indexOf(data.paginataal) !== -1 ? data.paginataal : 'en';

  window.hejBalk = {
    paginataal: paginataal,
    talen: TALEN,

    /* De taal van de winkel van dat land. Leeg als we dat land niet hebben; de beller valt
       dan terug op de taal van de pagina. */
    marktaal: function (landcode) {
      return (data.marktaal || {})[landcode] || '';
    },

    /* Landnaam in de vorm die achter "vanuit" past, in de gevraagde taal. Leeg als we het
       land niet kennen; de beller gebruikt dan de naam die Shopify geeft. */
    landnaam: function (taal, landcode) {
      return ((data.landnaam || {})[taal] || {})[landcode] || '';
    },

    taalnaam: function (taal, taalcode) {
      return ((data.taalnaam || {})[taal] || {})[taalcode] || taalcode;
    },

    /* Alle talen van de winkel van dat land. Meer dan één: alleen België. */
    markttalen: function (landcode) {
      var lijst = (data.markttalen || {})[landcode];
      return lijst && lijst.length ? lijst : [];
    },

    /* De naam van een taal in die taal zelf, voor op een taalknop: "Français", niet "Frans". */
    eigennaam: function (taalcode) {
      return (data.eigennaam || {})[taalcode] || taalcode;
    },

    /* De taal van de ZIN als de doelwinkel meer dan één taal heeft. Hier, en alleen hier,
       telt de browser mee: staat die op een van de talen van die winkel, dan die taal.
       Anders de standaard van die winkel.

       Waarom dit wel mag en de browsertaal elders niet: de knoppen ernaast staan elk in
       hun eigen taal. Zit de gok ernaast, dan ziet de bezoeker nog steeds zijn taal staan
       en klikt hij die aan. Op 2026-09-17 bepaalde de browser de hele boodschap, zonder
       zo'n uitweg, en dat was fout. */
    zinstaal: function (landcode) {
      var talen = this.markttalen(landcode);
      var ruw = (navigator.languages && navigator.languages[0]) || navigator.language || '';
      var browser = ruw.split('-')[0].toLowerCase();
      if (talen.indexOf(browser) !== -1) return browser;
      return this.marktaal(landcode) || paginataal;
    },

    tekst: function (groep, taal, sleutel) {
      var g = data[groep] || {};
      var set = g[taal] || g[paginataal] || g.en || {};
      return set[sleutel] || '';
    },

    vul: function (zin, vervangingen) {
      Object.keys(vervangingen || {}).forEach(function (teken) {
        zin = zin.split(teken).join(vervangingen[teken]);
      });
      return zin;
    }
  };
})();
